import { CHAIN_IDS } from '@/constants/chain';

import { isWrap } from '@/utils/swap';

import type { TradeQuote } from '../tradeQuote';
import type { ExecutionContext, SubmitLane } from './types';

type LaneSelectionContext = Pick<
  ExecutionContext,
  'sellToken' | 'buyToken' | 'chainId' | 'isSmartWallet'
>;

/** Resolves the executable submit lane from the engine quote and wallet capabilities. */
export function selectLane(quote: TradeQuote, ctx: LaneSelectionContext): SubmitLane {
  if (quote.source === 'advanced') return 'advanced';
  if (quote.source === 'cross-chain') return 'cross-chain';
  if (quote.source === 'intents') return 'intents';
  const isWrapPair = isWrap(ctx.sellToken.address, ctx.buyToken.address, ctx.chainId);
  if (ctx.sellToken.chainId === CHAIN_IDS.SOLANA) return isWrapPair ? 'solana-wrap' : 'solana';
  if (isWrapPair) return 'wrap';

  const allowance = quote.raw?.issues.allowance;
  if (
    ctx.isSmartWallet &&
    allowance &&
    quote.raw &&
    BigInt(allowance.actual) < BigInt(quote.raw.sellAmount)
  ) {
    return 'batch';
  }

  return 'evm';
}
